<template>
    <span class="text-heading-h5 text-secondary-text">
        <slot></slot>
    </span>
</template>
